import { Icons, tokens, Typography, Box, Stack } from '@cast/design-system';
import { Tendency } from '@cast/shared-types';
import { formatCurrency } from '@cast/utils';

import { getSummaryTendency } from '@cast/features-cluster-shared';

type SavingsCellProps = {
  value: number | null;
};

const tendencyColorMap: Record<Tendency, string> = {
  up: tokens.theme.fg.structural.primary,
  down: tokens.theme.fg.status.success,
  stable: tokens.theme.fg.structural.primary,
};

export const SavingsCell = ({ value }: SavingsCellProps) => {
  if (value == null) {
    return (
      <Typography
        variant="P12R"
        sx={{ color: tokens.theme.disabled.fg }}
        fontStyle="italic"
      >
        —
      </Typography>
    );
  }

  const tendency = getSummaryTendency(value);
  const Icon =
    tendency === 'up'
      ? Icons.CaretUp
      : tendency === 'down'
      ? Icons.CaretDown
      : null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={4}
      className={`Tendency-${tendency}`}
    >
      {Icon ? (
        <Box
          component={Icon}
          size={14}
          weight="fill"
          className="TendencyIndicator-icon"
          sx={{ color: tendencyColorMap[tendency], flexShrink: 0 }}
        />
      ) : null}
      <Typography
        variant="P12R"
        sx={{ color: tokens.theme.fg.structural.primary }}
        noWrap
      >
        {formatCurrency(Math.abs(value))}
      </Typography>
    </Stack>
  );
};
